// import {useAppDispatch} from "../../../hooks/useTypedReactRedux";


import {
    useAppDispatch,
    useAppSelector
} from "../../../../hooks/useTypedReactRedux.ts";
import {UserProfileAttribute} from "../types.ts";
import {recordSelector} from "../selectors.ts";
import {
    deleteUserProfileAttribute,
    fetchUserProfileAttribute,
    updateUserProfileAttribute
} from "../reducers/recordsSlice.ts";

export const useUserProfileAttribute = (id?: string) => {

    const dispatch = useAppDispatch();

    const {
        record,
        loading
    } = useAppSelector((state) => recordSelector(state, id ? id : ''));


    const fetchRecord = async () => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        dispatch(fetchUserProfileAttribute(id))
    };

    const updateRecord = async (id: string, record: UserProfileAttribute) => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        dispatch(updateUserProfileAttribute({
                                                id,
                                                record
                                            }))
    }

    const deleteRecord = async (id: string) => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        dispatch(deleteUserProfileAttribute(id))
    }

    return {
        record,
        loading,
        fetchRecord,
        updateRecord,
        deleteRecord
    }
}
